import React from "react";

/** 16:9 responsive YouTube iframe. `rel=0` disables related videos.
 * No autoplay per Phase 6 spec. */
export const TrailerEmbed = ({ videoId, title = "Trailer" }) => {
    if (!videoId) return null;
    return (
        <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-black" data-testid="trailer-embed">
            <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                    title={title}
                    src={`https://www.youtube.com/embed/${videoId}?rel=0`}
                    frameBorder="0"
                    allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 h-full w-full"
                    data-testid="trailer-iframe"
                />
            </div>
        </div>
    );
};

export default TrailerEmbed;
